<template>
    <b-modal id="complaint_respond" ref="complaint_respond" @hidden="resetModal" no-close-on-backdrop>

        <template v-slot:modal-title>
            <div>
                Complaint Respond
            </div>
        </template>

        <div class="mb-4">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ducimus, neque.
        </div>

        <b-form>
            <b-row class="">
                <b-colxx md="6">
                    <b-form-group label="Assigned To " class="has-float-label">
                        <template v-slot:label>
                            <span>Assigned To <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateInspector" v-model="selected.inspector" :options="inspectors"
                                  :border-danger="'assigned_id' in errors"/>

                        <b-form-invalid-feedback :state="!'assigned_id' in errors"
                                                 v-text="'assigned_id' in errors ? errors.assigned_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Respond Date" class="has-float-label">
                        <template v-slot:label>
                            <span>Respond Date <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus" mode="single"
                            v-model="datepicker.date"
                            @input="'date' in errors ? delete errors.date : ''"
                            :input-props="{ class:'form-control' + ('date' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'date' in errors"
                                                 v-text="'date' in errors ? errors.date[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group>
                        <b-form-checkbox v-model="form.work_completed">Work Completed</b-form-checkbox>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Outcome" class="has-float-label">
                        <template v-slot:label>
                            <span>Outcome <sup><code>*</code></sup></span>
                        </template>

                        <b-form-textarea rows="4" v-model="form.outcome"
                                         :class="{'border-danger': 'outcome' in errors}"
                                         @input="'outcome' in errors ? (delete errors.outcome) : ''"
                                         autocomplete="off" placeholder="Outcome"/>

                        <b-form-invalid-feedback :state="!'outcome' in errors"
                                                 v-text="'outcome' in errors ? errors.outcome[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <vue-dropzone ref="fileDropZone" id="dropzone"
                                  @vdropzone-error="attachmentError"
                                  :destroy-dropzone="false" :options="dropzoneOptions"/>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('complaint_respond')" v-text="'Cancel'"/>

            <state-button size="sm" variant="primary" :click="submitComplaintRespond">Submit</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";
import {mapGetters} from "vuex";
import VueDropzone from 'vue2-dropzone';
import moment from "moment";

export default {
    name: "RespondFormModal",

    components: {
        StateButton,
        VueDropzone
    },

    props: [
        'complaint'
    ],

    data() {
        return {
            datepicker: {
                date: null,
            },
            selected: {
                inspector: [],
            },
            dropzoneOptions: {
                url: 'url',
                thumbnailHeight: 160,
                acceptedFiles: '.jpg,.jpeg,.png,.pdf',
                maxFilesize: 10,
                previewTemplate: this.dropzoneTemplate(),
                headers: {
                    'Authorization': 'Bearer ' + this.$store.getters.accessToken
                },
                dictDefaultMessage: 'Drop or Click here to upload files.<br>Max file size 10MB.<br>Accepted file types: JPG, JPEG, PNG, PDF.',
                autoProcessQueue: false
            },
        }
    },

    computed: {
        ...mapGetters({
            form: 'getComplaintRespondForm',
            errors: 'getComplaintErrors',
            inspectors: 'getSelectInspectors',
        }),
    },

    watch: {
        'datepicker.date'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.date = null;
            this.form.date = moment(date).format('YYYY-MM-DD');
        },
    },

    mounted() {
        this.getInspectors();
    },

    methods: {
        async getInspectors() {
            await this.$store.dispatch('fetchSelectInspectors');
        },

        updateAssigned(field) {
            if (field) {
                this.form.assigned_as = field.value;
            } else {
                this.form.assigned_as = '';
            }
            'assigned_as' in this.errors ? delete this.errors.assigned_as : '';
        },

        submitComplaintRespond() {
            return new Promise((success, fail) => {
                this.$store.dispatch('submitComplaintRespond', this.form)
                    .then(response => {
                        this.uploadFiles(response.data);
                    })
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.$notify('success filled', 'Success!', 'Added complaint respond!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('complaint_respond');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        updateInspector(field) {
            if (field) {
                this.form.assigned_id = field.user_id;
            } else {
                this.form.assigned_id = '';
            }
            'assigned_id' in this.errors ? delete this.errors.assigned_id : '';
        },

        resetModal() {
            this.$store.commit('setComplaintRespondForm');

            this.datepicker =  {
                date: null,
            };

            this.selected = {
                inspector: [],
            };
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        attachmentError(file, message, xhr) {
            this.$refs.fileDropZone.removeFile(file);
            this.$notify('error filled', 'Error!', file.name + " could not be added!", {
                duration: 6000,
                permanent: false
            });
        },

        uploadFiles(respond) {
            let url = '/api/hms/compliances/complaints/' + this.complaint.complaint_id + '/respond/attachments';

            this.$refs.fileDropZone.setOption('url', url);

            this.$refs.fileDropZone.processQueue(respond);
        },

        dropzoneTemplate() {
            return `<div class="dz-preview dz-file-preview mb-3">
                  <div class="d-flex flex-row "> <div class="p-0 w-30 position-relative">
                      <div class="dz-error-mark"><span><i></i>  </span></div>
                      <div class="dz-success-mark"><span><i></i></span></div>
                      <div class="preview-container">
                        <img data-dz-thumbnail class="img-thumbnail border-0" />
                        <i class="simple-icon-doc preview-icon"></i>
                      </div>
                  </div>
                  <div class="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                    <div> <span data-dz-name /> </div>
                    <div class="text-primary text-extra-small" data-dz-size /> </div>
                    <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>
                  </div>
                  <a href="#" class="remove" data-dz-remove> <i class="glyph-icon simple-icon-trash"></i> </a>
                </div>`
        },
    },
}
</script>

<style scoped>

</style>
